import React from "react";
import { FileText } from "react-feather";
import { useHasPermission } from "../../auth/useClaims";
import { useBranchFilter } from "../../branchFilter/useBranchFilter";
import { useListLposQuery } from "../../stock/stockApi";
import { money, sumBy } from "../dashboardHelpers";
import KpiCard from "../components/KpiCard";
import { paths } from "../../../routes/paths";

// Same unscoped GET /stock/lpos?pageSize=500 call as RecentLposCard - RTK
// Query dedupes it, one real request either way.
const PendingLposKpi = () => {
  const canView = useHasPermission("Stock.ViewLpo");
  const { selectedBranchId } = useBranchFilter();

  const { data: lpoAll, isFetching } = useListLposQuery(
    { branchId: selectedBranchId ?? undefined, pageSize: 500 },
    { skip: !canView }
  );

  if (!canView) return null;

  const items = lpoAll?.items || [];
  const pending = items.filter((l) => l.status === "SUBMITTED" || l.status === "REVISED_SUBMITTED");
  const pendingValue = sumBy(pending, "netAmount");

  return (
    <div className="col-6 col-xl-3">
      <KpiCard
        icon={<FileText size={20} />}
        iconBg="#F59E0B"
        label="Pending LPOs"
        value={isFetching ? "..." : pending.length}
        caption={`Total Value ${money(pendingValue)}`}
        // "PENDING" is the pseudo-status the LPO list expands back into the
        // same SUBMITTED + REVISED_SUBMITTED pair counted here, so the list
        // shows exactly these LPOs and not a superset.
        drillTo={paths.stockLposFiltered({ status: "PENDING" })}
        drillTitle="See the LPOs waiting for approval"
      />
    </div>
  );
};

export default PendingLposKpi;
